

import styled from 'styled-components';

import { colors } from '../shared/tokens';
import Nav from './Nav';
import Footer from './Footer';
import Hero from './sections/Hero';
import Industries from './sections/Industries';
import Stats from './sections/Stats';
import Platform from './sections/Platform';
import Products from './sections/Products';
import Together from './sections/Together';

const LandingPage = () => (
  <Page>
    <Nav />
    <main>
      <Hero />
      <div id="solutions">
        <Industries />
      </div>
      <Stats />
      <Platform />
      <Products />
      <div id="about">
        <Together />
      </div>
    </main>
    <div id="contact">
      <Footer />
    </div>
  </Page>
);

export default LandingPage;

const Page = styled.div`
  position: relative;
  width: 100%;
  min-height: 100vh;
  background: ${colors.bg};
  overflow-x: hidden;
`;
